
$(document).ready(function() {
  
  // Product Varinat
  $('#tabs-nav li').click(function() {
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
  });
  
  if ('.active .varinat-change-trigger') {
    var value = $('.tab-label').data('value');
    $('.variant-input-wrap[name="Size"] .variant-input').each(function(){
      var title = $(this).data('value');
      if(title.indexOf(value) > -1){
        $(this).addClass('hide');
        $(this).addClass('variant--print');
      }else{
        $(this).removeClass('hide');
        $(this).addClass('variant--canvas');
      }
    });
    $('.variant--canvas').children().first().next('label').trigger('click');
  }
  
  $(document).on('click','.tab-label',function(e){ 
    var value = $(this).data('value');
    console.log('value == >> '+value);
    $('.variant-input-wrap[name="Frame"] .variant-input').each(function() {
      $('.frame-style').children().first().next('label').trigger('click');
    });
    
    $('.variant-input-wrap[name="white border"] .variant-input').each(function() {
      $('.border-style').children().first().next('label').trigger('click');
    });
    
    setTimeout(function(){
      var size_canvas_var = $('.variant-input-wrap[name="Size"] .variant--canvas input:checked').val();
      var size_print_var = $('.variant-input-wrap[name="Size"] .variant--print input:checked').val();
      $('.style-size').text(size_canvas_var);
      $('.style-size').text(size_print_var); 
    }, 300);
    
    $('.variant-input-wrap[name="Size"] .variant-input').each(function() {
      var title = $(this).data('value');
      console.log('title --> '+title);
      if(title.indexOf(value) > -1) {
        $('.variant--canvas').removeClass('hide');
        $('.variant--print').addClass('hide');
       $('.variant--canvas').children().first().next('label').trigger('click');
      } else {
        $('.variant--print').removeClass('hide');
        $('.variant--canvas').addClass('hide');
       $('.variant--print').children().first().next('label').trigger('click');
      }
    });
    
  });
  
  // Responsive Mobile Dropdown
  if ('.active .logic-varinat-change-trigger') {
    var logic_value = $('.logic-tab-label').data('value');
    $('.logic-variant .logic-variant-select .variant-input[name="Size"]').each(function(){
      var logic_title = $(this).data('value');
      if(logic_title.indexOf(logic_value) > -1) {
        $(this).addClass('hide');
        $(this).prop('disabled', true);
        $(this).addClass('logic-variant--print');
      }else{
        $(this).removeClass('hide');
        $(this).prop('disabled', false);
        $(this).addClass('logic-variant--canvas');
      }
    });
    $('.logic-variant-select option.logic-variant--print').removeAttr('selected','selected').click();
    $(".logic-variant-select option.logic-variant--canvas:first").attr('selected','selected').click();
  }
  
  // Click Trigger
  $(document).on('change','.logic-variant-select',function(e) {
    var selected = $('.logic-variant-select option:selected').val();
    $('.var_mob-hide .variant-input-wrap[name="Size"] .variant-input').each(function() {
      var logic_label = $(this).find('input').val();
      if(selected == logic_label){
        $(this).find('label').trigger('click');
        //console.log(logic_label)
      }
    });
  });
  
  $(document).on('click','.logic-tab-label',function(e) {
    var logic_value = $(this).data('value');
    $('.var_mob-show .logic-variant .logic-variant-select .variant-input[name="Size"]').each(function() {
      var logic_label = $('.logic-tab-label').data('value');
      
      if (logic_label.indexOf(logic_value) > -1) {
        
        var sub_imgs_class = $('.starting-slide .product-image-main .wc-product-image-main');
        $('.starting-slide .wc-propage').removeClass('wc-canvas_spacing');
        $('.starting-slide .wc-propage').addClass('wc-print_spacing');
        sub_imgs_class.removeClass('wc-canvas-black');
        sub_imgs_class.removeClass('wc-canvas-white');
        sub_imgs_class.removeClass('wc-canvas-frame');
        sub_imgs_class.removeClass('wc-canvas-oak');
        
        $(this).addClass('hide');
        $('.logic-variant-select option.logic-variant--print').removeClass('hide');
        $('.logic-variant-select option.logic-variant--canvas').prop('disabled', true);
        $('.logic-variant-select option.logic-variant--print').prop('disabled', false);
        $('.logic-variant-select option.logic-variant--print:first').attr('selected','selected').trigger('click');
        $('.logic-variant-select option.logic-variant--canvas').removeAttr('selected','selected').trigger('click');
        $('.logic-variant-select').prop('selected', true);
        
        var selected = $('.logic-variant-select option:selected').val();
        $('.var_mob-hide .variant-input-wrap[name="Size"] .variant-input').each(function() {
          var logic_label = $(this).find('input').val();
          if(selected == logic_label){
            $(this).find('label').trigger('click');
          }
        });
        
      } else {
        
        var sub_imgs_class = $('.starting-slide .product-image-main .wc-product-image-main');
        $('.starting-slide .wc-propage').removeClass('wc-print_spacing');
        $('.starting-slide .wc-propage').addClass('wc-canvas_spacing');
        sub_imgs_class.removeClass('wc-print-black');
        sub_imgs_class.removeClass('wc-print-white');
        sub_imgs_class.removeClass('wc-print-frame');
        sub_imgs_class.removeClass('wc-print-unframed');
        sub_imgs_class.removeClass('wc-print-oak');
        
        
        $(this).addClass('hide');
        $('.logic-variant-select option.logic-variant--canvas').removeClass('hide');
        $('.logic-variant-select option.logic-variant--print').prop('disabled', true);
        $('.logic-variant-select option.logic-variant--canvas').prop('disabled', false);
        $('.logic-variant-select option.logic-variant--canvas:first').attr('selected','selected').trigger('click');
        $('.logic-variant-select option.logic-variant--print').removeAttr('selected','selected').trigger('click');
        $('.logic-variant-select').prop('selected', true);
        
      }
    });
    
    var size_canvas_var = $('.logic-variant-select').find('option:selected').val();
    setTimeout(function(){
      $('.style-size').text(size_canvas_var); 
    }, 100);

  });
  
  $(document).on('change','.select-dropdown',function(e) {
    var opt_value = $(this).find('option:selected').data('price');
    console.log(opt_value)
    setTimeout(function(){
      $('.product__price').text(opt_value); 
      $('.cart-product__price').text(opt_value);
    }, 100);
  });
  
  
  $('.frame-switch input:checkbox').change(function() {
    if($(this).is(":checked")) {
      $('.frame-switch').addClass("active");
      $('div.on-off').addClass("btn-active");
      $('.frame-border').removeClass('hide');
    } else {
      $('.frame-switch').removeClass("active");
      $('div.on-off').removeClass("btn-active");
      $('.frame-border').addClass('hide');
    }
  });
  // Auto-enable frame options on page load
$('.frame-switch input:checkbox').prop('checked', true);
$('.frame-switch').addClass('active');
$('div.on-off').addClass('btn-active');
$('.frame-border').removeClass('hide');
  
  $(document).on('click', '.tab-label', function(){
    var data_val = $(this).attr('data-value');
    if(data_val == 'Canvas'){
      $('.border-style').addClass('wc-white-frame');
      $('.wc-canvas-hide .border-style.wc-white-frame').each(function(){
        var canvas_val = $(this).attr('data-value');
        if(canvas_val == 'White'){
          $(this).hide();
        }else{
          $(this).show();
        }
      });
    }else{
      $('.border-style').removeClass('wc-white-frame');
      $('.wc-canvas-hide .border-style').show();
    }
  });
  
  
  $(document).on('click', '.logic-tab-label', function() {
    var data_val = $(this).attr('data-value');
    if(data_val == 'canvas'){
      $('.border-style').addClass('wc-white-frame');
      $('.wc-canvas-hide .border-style.wc-white-frame').each(function(){
        var canvas_val = $(this).attr('data-value');
        if(canvas_val == 'White'){
          $(this).hide();
        }else{
          $(this).show();
        }
      });
    }else{
      $('.border-style').removeClass('wc-white-frame');
      $('.wc-canvas-hide .border-style').show();
    }
  });
  

});

(function($) {
  
  $(document).on('click', '.frame-border .variant-input-wrap label', function(){
    var win_width = $(window).width();

      var size_value_text = $(this).parents('.var_mob-hide').find('.variant-size .variant-input-wrap[name="Size"] .variant-input input:checked').data('value');
      var size_value = size_value_text.toLowerCase();
      var input_val_frame = $(this).parent('.variant-input').find('input').data('value');
      if (input_val_frame !== "undefined") {
        var input_val = input_val_frame.replace(/[_\s]/g, '-').replace(/[^a-z0-9-\s]/gi, '').toLowerCase();
      }
    
      var img_class = $('.starting-slide .product-image-main .wc-product-image-main');
    
      if ($(".variant-input").hasClass("border-style")) {
        
        if (size_value == 'canvas') {
          img_class.removeClass('wc-print-border-none');
          img_class.removeClass('wc-print-border-white');
          img_class.removeClass('wc-print-frame');
          img_class.addClass('wc-canvas-frame');
          if(input_val == 'border-white' || input_val == 'yes'){
            img_class.addClass('wc-canvas-'+input_val);
            img_class.removeClass('wc-canvas-border-none');
          } else if (input_val == 'border-none'){
            img_class.addClass('wc-canvas-'+input_val);
            img_class.removeClass('wc-canvas-border-white');
          }
        } else {
          img_class.removeClass('wc-canvas-border-none');
          img_class.removeClass('wc-canvas-border-white');
          img_class.removeClass('wc-canvas-frame');
          img_class.addClass('wc-print-frame');
          if(input_val == 'border-white' || input_val == 'yes'){
            img_class.addClass('wc-print-'+input_val);
            img_class.removeClass('wc-print-border-none');
          } else if (input_val == 'border-none'){
            img_class.addClass('wc-print-'+input_val);
            img_class.removeClass('wc-print-border-white');
          }
        }
      }
      
      var sub_img_class = $('.starting-slide .product-image-main .wc-product-image-main');
      if ($(".variant-input").hasClass("frame-style")) {
        if (size_value == 'canvas') {
          $('.starting-slide .wc-propage').removeClass('wc-print_spacing');
          $('.starting-slide .wc-propage').addClass('wc-canvas_spacing');
          sub_img_class.removeClass('wc-print-black');
          sub_img_class.removeClass('wc-print-white');
          sub_img_class.removeClass('wc-print-frame');
          sub_img_class.removeClass('wc-print-unframed');
          sub_img_class.removeClass('wc-print-oak');
          if(input_val == 'oak'){
            sub_img_class.addClass('wc-canvas-'+input_val);
            sub_img_class.removeClass('wc-canvas-black');
            sub_img_class.removeClass('wc-canvas-white');
            sub_img_class.removeClass('wc-canvas-frame');
          }else if(input_val == 'black'){
            sub_img_class.addClass('wc-canvas-'+input_val);
            sub_img_class.removeClass('wc-canvas-oak');
            sub_img_class.removeClass('wc-canvas-white');
            sub_img_class.removeClass('wc-canvas-frame');
          }else if(input_val == 'white'){
            sub_img_class.addClass('wc-canvas-'+input_val);
            sub_img_class.removeClass('wc-canvas-black');
            sub_img_class.removeClass('wc-canvas-oak');
            sub_img_class.removeClass('wc-canvas-frame');
          }else if(input_val == 'frame' || input_val == 'unframed'){
            sub_img_class.addClass('wc-canvas-'+input_val);
            sub_img_class.removeClass('wc-canvas-black');
            sub_img_class.removeClass('wc-canvas-white');
            sub_img_class.removeClass('wc-canvas-oak');
          }
        } else {
          $('.starting-slide .wc-propage').removeClass('wc-canvas_spacing');
          $('.starting-slide .wc-propage').addClass('wc-print_spacing');
          sub_img_class.removeClass('wc-canvas-black');
          sub_img_class.removeClass('wc-canvas-white');
          sub_img_class.removeClass('wc-canvas-frame');
          sub_img_class.removeClass('wc-canvas-oak');
          if(input_val == 'oak'){
            sub_img_class.addClass('wc-print-'+input_val);
            sub_img_class.removeClass('wc-print-black');
            sub_img_class.removeClass('wc-print-white');
            sub_img_class.removeClass('wc-print-frame');
          }else if(input_val == 'black'){
            sub_img_class.addClass('wc-print-'+input_val);
            sub_img_class.removeClass('wc-print-oak');
            sub_img_class.removeClass('wc-print-white');
            sub_img_class.removeClass('wc-print-frame');
          }else if(input_val == 'white'){
            sub_img_class.addClass('wc-print-'+input_val);
            sub_img_class.removeClass('wc-print-black');
            sub_img_class.removeClass('wc-print-oak');
            sub_img_class.removeClass('wc-print-frame');
          }else if(input_val == 'frame' || input_val == 'unframed'){
            sub_img_class.addClass('wc-print-'+input_val);
            sub_img_class.removeClass('wc-print-black');
            sub_img_class.removeClass('wc-print-white');
            sub_img_class.removeClass('wc-print-oak');
          }
        }
      }
      
    

  });
})( jQuery );

$(window).on('load', function(){
  
  $('.variant-input-wrap[name="Frame"] .variant-input').addClass('frame-style');
  $('.variant-input-wrap[name="white border"] .variant-input').addClass('border-style');
  
  setTimeout(function(){
    var size_canvas_var = $('.variant-input-wrap[name="Size"] .variant--canvas input:checked').val();
    var size_print_var = $('.variant-input-wrap[name="Size"] .variant--print input:checked').val();
    var frame_canvas_var = $('.variant-input-wrap[name="Frame"] .frame-style input:checked').val();
    var border_print_var = $('.variant-input-wrap[name="white border"] .border-style input:checked').val();
    
    
    $('.style-size').text(size_canvas_var);
    $('.style-size').text(size_print_var);
    $('.style-frame').text(frame_canvas_var);
    $('.style-border').text(border_print_var);
    
    $('.variant-input-wrap[name="Frame"] .variant-input').each(function() {
      $('.frame-style').children().first().next('label').trigger('click');
    });

    $('.variant-input-wrap[name="white border"] .variant-input').each(function() {
      $('.border-style').children().first().next('label').trigger('click');
    });
    
  }, 300);
  
  var data_val = $('.tab-label.active').attr('data-value');
  if(data_val == 'Canvas'){
    $('.border-style').addClass('wc-white-frame');
    $('.wc-canvas-hide .border-style.wc-white-frame').each(function(){
      var canvas_val = $(this).attr('data-value');
      if(canvas_val == 'White'){
        $(this).hide();
      }else{
        $(this).show();
      }
    });
  }else{
    $('.border-style').removeClass('wc-white-frame');
    $('.wc-canvas-hide .border-style').show();
  }
  
  var size_value = $(this).parents('.var_mob-hide').find('.variant-size .variant-input-wrap[name="Size"] .variant-input input:checked').data('value');
  var input_val_frame = $(this).parent('.variant-input').find('input').data('value');
  if (input_val_frame === "undefined") {
    var input_val = input_val_frame.replace(/[_\s]/g, '-').replace(/[^a-z0-9-\s]/gi, '').toLowerCase();
  }

  var img_class = $('.starting-slide .product-image-main .wc-product-image-main');
  
  if ($(".variant-input").hasClass("border-style")) {
    if (size_value == 'canvas') {
      img_class.removeClass('wc-print-border-none');
      img_class.removeClass('wc-print-border-white');
      if(input_val == 'border-white' || input_val == 'yes'){
        img_class.addClass('wc-canvas-'+input_val);
        img_class.removeClass('wc-canvas-border-none');
      } else if (input_val == 'border-none'){
        img_class.addClass('wc-canvas-'+input_val);
        img_class.removeClass('wc-canvas-border-white');
      }
    } else {
      img_class.removeClass('wc-canvas-border-none');
      img_class.removeClass('wc-canvas-border-white');
      if(input_val == 'border-white' || input_val == 'yes'){
        img_class.addClass('wc-print-'+input_val);
        img_class.removeClass('wc-print-border-none');
      } else if (input_val == 'border-none'){
        img_class.addClass('wc-print-'+input_val);
        img_class.removeClass('wc-print-border-white');
      }
    }
  }

  var sub_img_class = $('.starting-slide .product-image-main .wc-product-image-main');
  if ($(".variant-input").hasClass("frame-style")) {
    if (size_value == 'canvas') {
      sub_img_class.removeClass('wc-print-black');
      sub_img_class.removeClass('wc-print-white');
      sub_img_class.removeClass('wc-print-frame');
      sub_img_class.removeClass('wc-print-oak');
      if(input_val == 'oak'){
        $('.starting-slide .product-image-main .wc-product-image-main').addClass('wc-canvas-'+input_val);
        sub_img_class.removeClass('wc-canvas-black');
        sub_img_class.removeClass('wc-canvas-white');
        sub_img_class.removeClass('wc-canvas-frame');
      }else if(input_val == 'black'){
        sub_img_class.addClass('wc-canvas-'+input_val);
        sub_img_class.removeClass('wc-canvas-oak');
        sub_img_class.removeClass('wc-canvas-white');
        sub_img_class.removeClass('wc-canvas-frame');
      }else if(input_val == 'white'){
        sub_img_class.addClass('wc-canvas-'+input_val);
        sub_img_class.removeClass('wc-canvas-black');
        sub_img_class.removeClass('wc-canvas-oak');
        sub_img_class.removeClass('wc-canvas-frame');
      }else if(input_val == 'frame'){
        sub_img_class.addClass('wc-canvas-'+input_val);
        sub_img_class.removeClass('wc-canvas-black');
        sub_img_class.removeClass('wc-canvas-white');
        sub_img_class.removeClass('wc-canvas-oak');
      }
    } else {
      sub_img_class.removeClass('wc-canvas-black');
      sub_img_class.removeClass('wc-canvas-white');
      sub_img_class.removeClass('wc-canvas-frame');
      sub_img_class.removeClass('wc-canvas-oak');
      if(input_val == 'oak'){
        $('.starting-slide .product-image-main .wc-product-image-main').addClass('wc-print-'+input_val);
        sub_img_class.removeClass('wc-print-black');
        sub_img_class.removeClass('wc-print-white');
        sub_img_class.removeClass('wc-print-frame');
      }else if(input_val == 'black'){
        sub_img_class.addClass('wc-print-'+input_val);
        sub_img_class.removeClass('wc-print-oak');
        sub_img_class.removeClass('wc-print-white');
        sub_img_class.removeClass('wc-print-frame');
      }else if(input_val == 'white'){
        sub_img_class.addClass('wc-print-'+input_val);
        sub_img_class.removeClass('wc-print-black');
        sub_img_class.removeClass('wc-print-oak');
        sub_img_class.removeClass('wc-print-frame');
      }else if(input_val == 'frame' || input_val == 'unframed'){
        sub_img_class.addClass('wc-print-'+input_val);
        sub_img_class.removeClass('wc-print-black');
        sub_img_class.removeClass('wc-print-white');
        sub_img_class.removeClass('wc-print-oak');
      }
    }
  }

});

$(document).on('click', '.variant--canvas', function(){
  var size_canvas_var = $(this).find('input:checked').val();
  setTimeout(function(){  
    $('.style-size').text(size_canvas_var);
  }, 100);
});

$(document).on('click', '.variant--print', function(){
  var size_print_var = $(this).find('input:checked').val();
  setTimeout(function(){
    $('.style-size').text(size_print_var); 
  }, 100);
});

$(document).on('click', '.frame-style', function(){
  var frame_canvas_var = $(this).find('input:checked').val();
  setTimeout(function(){
    $('.style-frame').text(frame_canvas_var); 
  }, 100);
});

$(document).on('click', '.border-style', function(){
  var border_print_var = $(this).find('input:checked').val();
  setTimeout(function(){
    $('.style-border').text(border_print_var); 
  }, 100);
});

$(document).on('click', '.logic-variant-select', function(){
  var size_canvas_var = $(this).find('option:selected').val();
  setTimeout(function(){
    $('.style-size').text(size_canvas_var); 
  }, 100);
});


$(document).ready(()=>{
  	$('.tab-label').first().click()
})
